let streamingOn = null;

export function setStreamingOn(val){
    console.log("Setting stream to:", val);
    streamingOn = val;
}

export function isStreamingOn(){
    if(streamingOn == null){
        let conf = localStorage.getItem("streaming.on");
        if(conf == null){
            streamingOn = false;
        } else {
            streamingOn = !!(conf && conf !== "false");
        }
    }
    return streamingOn;
}
